import {ApplicationRoute, LOCALIZED_ROUTE_TOKEN} from '../../craft/utils/application.route'

export const PRO_ROUTES = {
  PRO: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/pro`), // hardcoded in app-routing user-default-route for tree shaking routes
  PRO_HOME: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/pro/home`),
  PRO_HOME_ACTION_NEEDED_JOBS: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/pro/home/jobs/actions`, 'jobs/actions'),
  PRO_HOME_CONFIRMED_JOBS: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/pro/home/jobs/confirmed`, 'jobs/confirmed'),
  PRO_HOME_ACQUISITION_JOBS: new ApplicationRoute(
    `/${LOCALIZED_ROUTE_TOKEN}/pro/home/jobs/acquisition`,
    'jobs/acquisition',
  ),
  PRO_HOME_LOST_JOBS: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/pro/home/jobs/lost`, 'jobs/lost'),
  PRO_HOME_COMPLETED_JOBS: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/pro/home/jobs/completed`, 'jobs/completed'),
  PRO_HOME_ALL_JOBS: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/pro/home/jobs/all`, 'jobs/all'),
  PRO_INVOICES: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/pro/invoices`),
  PRO_NEW_JOB: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/pro/jobs/:id/accept`, 'jobs/:id/accept'),
  PRO_JOB_FREE_MARKET: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/pro/find/jobs`, 'find/jobs'),
  PRO_JOB_DETAILS: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/pro/jobs/:id`, 'jobs/:id'),
  PRO_JOB_DETAILS_OVERVIEW_TAB: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/pro/jobs/:id/overview`, 'overview'),
  PRO_JOB_DETAILS_CHAT_TAB: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/pro/jobs/:id/chats`, 'chats'),
  PRO_JOB_DETAILS_CHATS_TAB_CONVERSATION: new ApplicationRoute(
    `/${LOCALIZED_ROUTE_TOKEN}/pro/jobs/:id/chats/:roomId`,
    ':roomId',
  ),
  PRO_JOB_DETAILS_JOB_DETAILS_TAB: new ApplicationRoute(
    `/${LOCALIZED_ROUTE_TOKEN}/pro/jobs/:id/job-details`,
    'job-details',
  ),
  PRO_JOB_DETAILS_CLIENT_DETAILS_TAB: new ApplicationRoute(
    `/${LOCALIZED_ROUTE_TOKEN}/pro/jobs/:id/client-details`,
    'client-details',
  ),

  PRO_SETTINGS: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/pro/settings`),
  PRO_SETTINGS_COMPETENCES: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/pro/settings/competences`, 'competences'),
  PRO_SETTINGS_USERS: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/pro/settings/users`, 'users'),
  PRO_SETTINGS_COMPANY_PROFILE: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/pro/settings/profile`, 'profile'),
  PRO_SETTINGS_SUBSCRIPTION: new ApplicationRoute(
    `/${LOCALIZED_ROUTE_TOKEN}/pro/settings/subscription`,
    'subscription',
  ),
  PRO_SETTINGS_SUBSCRIPTION_SUCCESS: new ApplicationRoute(
    `/${LOCALIZED_ROUTE_TOKEN}/pro/settings/subscription/success`,
    'subscription/success',
  ),
  PRO_SETTINGS_LOCATIONS: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/pro/settings/locations`, 'locations'),
  PRO_SETTINGS_MARKETING: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/pro/settings/marketing`, 'marketing'),
  PRO_SETTINGS_PAYOUT: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/pro/settings/payout`, 'payout'),
  PRO_SETTINGS_CHAT: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/pro/settings/chat`, 'chat'),
}
